<script lang="ts">
  import Error from "$lib/components/icons/Error.svelte";
  import Info from "$lib/components/icons/Info.svelte";
  import Success from "$lib/components/icons/Success.svelte";
  import Warning from "$lib/components/icons/Warning.svelte";
  import { Toast } from "flowbite-svelte";
  import { type ComponentProps, createEventDispatcher } from "svelte";
  import { fly } from "svelte/transition";

  const dispatch = createEventDispatcher();

  export let id: number;
  export let variant: keyof typeof colorMap = "info";
  export let duration = 6000;

  let open = true;

  const colorMap: Record<string, ComponentProps<Toast>["color"]> = {
    info: "blue",
    success: "green",
    warning: "yellow",
    error: "red",
  };

  const timeout = setTimeout(() => (open = false), duration);

  $: if (open === false) {
    clearTimeout(timeout);
    open = false;
    dispatch("toast:closed", { id });
  }
</script>

<Toast
  bind:toastStatus={open}
  color={colorMap[variant]}
  class={$$props.class}
  transition={fly}
  params={{ x: 200 }}
>
  <span slot="icon" data-testid="toast-{id}" class="contents">
    {#if variant === "success"}
      <Success color="currentColor" />
    {:else if variant === "warning"}
      <Warning color="currentColor" />
    {:else if variant === "error"}
      <Error color="currentColor" />
    {:else}
      <Info color="currentColor" />
    {/if}
  </span>
  <slot />
</Toast>
